import { Col, Row } from 'antd';

import { FormSelect } from 'components';

import { useGetCompanies } from 'hooks';

export const CompanySelect = () => {
  const [{ companies, loading }] = useGetCompanies();

  const companyOptions = companies?.map(({ id, englishName }) => ({ label: englishName, value: id }));

  return (
    <Row>
      <Col xs={24}>
        <FormSelect
          label='Company'
          name={['retailerValues', 'companyId']}
          loading={loading}
          options={companyOptions}
          rules={[{
            message: 'Company is required!',
            required: true,
          }]}
        />
      </Col>
    </Row>
  );
};
